$(document).on('click', '.expands-row-click', function () {
  $($(this).closest('.expands-row').data('expand')).slideToggle(5);
});